import React, { useMemo } from 'react'
import numeral from 'numeral'
import { createColumnHelper, getCoreRowModel, useReactTable } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Table from '../../../Invoices/Table'
import MarginCell from '../MarginCell'

import styles from './styles.module.scss'
import { getCurrency } from '../../../../helpers/currencies'

const columnHelper = createColumnHelper()

const Placeholder = () => {
  const { t } = useTranslation()
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        aria-hidden="true"
        className="lucide lucide-clipboard-list h-8 w-8"
      >
        <rect width={8} height={4} x={8} y={2} rx={1} ry={1} />
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2M12 11h4M12 16h4M8 11h.01M8 16h.01" />
      </svg>
      <div style={{color: '#333945', marginBottom : 4}}>{t('No entries logged')}</div>
      <div>{t('Pick a period to view')}</div>
    </div>
  )
}

const ProfitabilityCustomers = ({data}) => {
  const { t } = useTranslation()

  const companyInfo = useSelector(state => state.company.companyInfo)
  const currency = getCurrency(companyInfo?.currency)
  
  const columns = useMemo(() => ([
    columnHelper.accessor('customer_name', {
      id: 'customer_name',
      header: t('Customer'),
      enableSorting: false,
      cell: ({ getValue }) => getValue()
    }),
    columnHelper.accessor('cost', {
      id: 'cost',
      enableSorting: false,
      cell: ({ getValue }) => `${numeral(getValue() || 0).format('0,0.00')} ${currency.symbol}`,
      header: t('Cost'),
    }),
    columnHelper.accessor('revenue', {
      id: 'revenue',
      enableSorting: false,
      cell: ({ getValue }) => `${numeral(getValue() || 0).format('0,0.00')} ${currency.symbol}`,
      header: t('Revenue'),
    }),
    columnHelper.accessor('profit', {
      id: 'profit',
      enableSorting: false,
      cell: ({ getValue }) => {
        const color = getValue() > 0 ? '#10b981' : getValue() < 0 ? '#ef4444' : '#374151'
        return <span style={{color: color}}>{`${numeral(getValue() || 0).format('0,0.00')} ${currency.symbol}`}</span>
      },
      header: t('Profit'),
    }),
    columnHelper.accessor('margin', {
      id: 'status',
      enableSorting: false,
      cell: ({ getValue }) => <MarginCell value={getValue()} />,
      header: t('Margin'),
    }),
    
  ]), [t])

  const table = useReactTable({
    data: data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  })

  return (
    <div className={styles.container}>
      <Table
        table={table}
        columns={columns}
        placeholder={<Placeholder />}
        headerClassName={styles.tableHeader}
        tableClassName={styles.table} />
    </div>
  )
}

export default ProfitabilityCustomers
